// SIDEBAR LIST
import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { Label } from 'src/components/label';
import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} />;

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  trainers: icon('mdi:gymnastics'),
  gym: icon('map:gym'),
  members: icon('fa:id-card'),
  personalMembers: icon('tdesign:member-filled'),
  playList: icon('iconamoon:playlist-bold'),
  videos: icon('bxs:videos'),
  post: icon('material-symbols:post'),
  groups: icon('material-symbols:groups'),
  report: icon('ic:outline-report-problem'),
  moderation: icon('garden:moderation-26'),
  news_letter: icon('la:envelope-open-text'),
  faqs: icon('qlementine-icons:faq-16'),
  tickets: icon('flowbite:ticket-solid'),
  faqs_category: icon('mdi:faq'),
  launch_list: icon('material-symbols:rocket-launch'),
  referral: icon('mdi:gift-outline'),
};

// ----------------------------------------------------------------------

export const navData = [
  {
    subheader: '',
    items: [
      { title: 'Home', path: paths.dashboard.general.home, icon: ICONS.course },
      { title: 'Chat', path: paths.dashboard.general.chat, icon: ICONS.course },
    ],
  },
];

export const superAdminData = [
  {
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: paths.dashboard.general.dashboard,
        icon: ICONS.dashboard,
        enabledRootRedirect: true,
        children: [
          {
            title: 'Total Users',
            path: `${paths.dashboard.general.analytics_details}/total_users`,
          },
          {
            title: 'Daily Active Users',
            path: `${paths.dashboard.general.analytics_details}/dau`,
          },
          {
            title: 'Weekly Active Users',
            path: `${paths.dashboard.general.analytics_details}/wau`,
          },
          {
            title: 'Monthly Active Users',
            path: `${paths.dashboard.general.analytics_details}/mau`,
          },
          {
            title: 'Paid Users',
            path: `${paths.dashboard.general.analytics_details}/paid_users`,
          },
          {
            title: 'Active User Actions',
            path: `${paths.dashboard.general.analytics_details}/active_users`,
          },
          {
            title: 'New Users',
            path: `${paths.dashboard.general.analytics_details}/new_users`,
          },
          {
            title: 'User Activations',
            path: `${paths.dashboard.general.analytics_details}/user_activations`,
          },
          {
            title: 'Inactivity Buckets',
            path: `${paths.dashboard.general.analytics_details}/inactivity_buckets`,
          },
          {
            title: 'Feature Usage',
            path: `${paths.dashboard.general.analytics_details}/feature_usage`,
          },
          {
            title: 'MRR Details',
            path: `${paths.dashboard.general.analytics_details}/mrr`,
          },
          {
            title: 'Retention Cohort Analysis',
            path: `${paths.dashboard.general.analytics_details}/retention_cohort`,
          },
          {
            title: 'Retention by Cohort Type (Day 30)',
            path: `${paths.dashboard.general.analytics_details}/retention_by_type`,
          },
          {
            title: 'Top Friction Events',
            path: `${paths.dashboard.general.analytics_details}/top_friction_events`,
          },
        ],
      },
      {
        title: 'User Analytics',
        path: paths.dashboard.general.user_analytics,
        icon: ICONS.personalMembers,
        enabledRootRedirect: true,
        children: [
          {
            title: 'Daily Activity',
            path: `${paths.dashboard.general.user_analytics_details}/daily_activity`,
          },
          {
            title: 'Intake Nutrition',
            path: `${paths.dashboard.general.user_analytics_details}/intake_nutrition`,
          },
          {
            title: 'Recent Activity Timeline',
            path: `${paths.dashboard.general.user_analytics_details}/recent_activity`,
          },
          {
            title: 'User Feature Breakdown',
            path: `${paths.dashboard.general.user_analytics_details}/feature_breakdown`,
          },
        ],
      },
      { title: 'Gyms', path: paths.dashboard.general.list, icon: ICONS.gym },
      { title: 'Trainers', path: paths.dashboard.general.trainers, icon: ICONS.trainers },
      { title: 'Members', path: paths.dashboard.general.members, icon: ICONS.members },
      {
        title: 'Personal Members',
        path: paths.dashboard.general.perosnal_members,
        icon: ICONS.personalMembers,
      },
      { title: 'Playlists', path: paths.dashboard.general.admin_playlists, icon: ICONS.playList },
      { title: 'Videos', path: paths.dashboard.general.admin_videos, icon: ICONS.videos },
      { title: 'Posts', path: paths.dashboard.general.admin_posts, icon: ICONS.post },
      { title: 'Groups', path: paths.dashboard.general.admin_groups, icon: ICONS.groups },
      { title: 'Messages', path: paths.dashboard.general.admin_messages, icon: ICONS.chat },
      { title: 'Reports', path: paths.dashboard.general.reportlist, icon: ICONS.report },
      {
        title: 'Referral System',
        path: paths.dashboard.general.admin_referrals,
        icon: ICONS.referral,
      },
      { title: 'Moderation', path: paths.dashboard.general.moderationlist, icon: ICONS.moderation },
      { title: 'Newsletter', path: paths.dashboard.general.news_letter, icon: ICONS.news_letter },
      { title: 'FAQs', path: paths.dashboard.general.faqs, icon: ICONS.faqs },
      {
        title: 'FAQs Category',
        path: paths.dashboard.general.faqsCategory,
        icon: ICONS.faqs_category,
      },
      {
        title: 'FAQs Sub Category',
        path: paths.dashboard.general.faqsSubCategory,
        icon: ICONS.news_letter,
      },
      {
        title: 'Support Center',
        path: paths.dashboard.general.tickets,
        icon: ICONS.tickets,
      },
      {
        title: 'Feedback',
        path: paths.dashboard.general.feedbackList,
        icon: ICONS.tickets,
      },
      {
        title: 'Launch List',
        path: paths.dashboard.general.launch_list,
        icon: ICONS.launch_list,
      },
    ],
  },
];
